module.exports = __webpack_public_path__ + "53aaef5871e8044d27ed68e85d473ddb.jpg";